"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.directions = void 0;
exports.directions = [
    'top',
    'right',
    'bottom',
    'left'
];
